import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ToolsService {
  constructor() {}

  public static removerMascara(valor: string): string {
    return valor.replace(/\D/g, ''); // Remove todos os caracteres que não são dígitos
  }
}
